import React from 'react'
import swal from "sweetalert";
import ETDownloadModal from './ETDownloadModal'

import { DateInput } from "semantic-ui-calendar-react";
import moment from 'moment'
import { Button, MDBBtn, MDBModal, MDBModalBody, MDBModalHeader, MDBModalFooter } from 'mdbreact'
import { Icon, Menu, Popup, Message } from "semantic-ui-react";
import { connect } from "react-redux";
import colors from '../colors'
import { Segment, Sidebar } from "semantic-ui-react";
import { Link } from "react-router-dom";
import { DateRange } from 'react-date-range';


// import 'react-date-range/dist/styles.css'; // main css file
// import 'react-date-range/dist/theme/default.css'; // theme css file
import {
  getETDates,

  handleDateChange,

} from "../redux_components/actions/ETActions";
import calendar from "./calendar.ico";
class ETTable extends React.Component {
  constructor(props) {
    super(props)
    console.log(props.date)
    this.state = {
      modal: false,
      date: null,
      activeIndex: 0,
      date1: null,
      date2: null,
      submitdisable: false,
      loginmodal: false,
      mn_yrMonths:null,
      mn_selectedYear:null

    }
  }


  mn_YearChange = (e) => {
    if (e.target.value !== '#') {
      this.props.mn_getMonths(e.target.value)
      this.props.setmn_selectedYear(e.target.value)
      // this.setState({
      //   mn_selectedYear: e.target.value
      // })
    } else {
      this.props.setmn_selectedYear(null)
    }
  }

  etmn_setSelectedMonth = (e) => {
    if (e.target.value !== '#') {
      this.props.setmn_selectedMonth(e.target.value)
    }else
    {
      this.props.setmn_selectedMonth(null)
    }
  }

  fn_YearChange = (e) => {

    this.props.setfn_selectedMonth('#')
      this.props.setfn_selectedFortnight('#')
    // this.props.setSelectedFNLayer("", "")
// console.log('blablablalblabla')
    if (e.target.value !== '#') {
      this.props.fn_getMonths(e.target.value)
      this.props.setfn_selectedYear(e.target.value)
    }else{
      this.props.setfn_selectedYear(null)
      // this.props.setfn_selectedMonth(null)
      // this.props.setfn_selectedFortnight(null)

    }
  }


  etfn_setSelectedMonth = (e) => {
    if (e.target.value !== '#') {
      this.props.setfn_selectedFortnight('#')
      this.props.setfn_selectedMonth(e.target.value)
      this.props.fn_MonthChange(e.target.value)
    }else
    {
      this.props.setfn_selectedMonth(null)
      this.props.setfn_selectedFortnight(null)
    }
  }

  etfn_setSelectedFortnight = (e) => {
    if (e.target.value !== '#') {
      this.props.setfn_selectedFortnight(e.target.value)
    }else
    {
      this.props.setfn_selectedFortnight(null)
    }
  }


  componentDidMount() {
    this.props.getETDates('Evapotranspiration')
  }
  handleDateChange = (event, { name, value }) => {
    // let selected_date = moment(value, "DD-MM-YYYY").format("YYYYMMDD");
    if (this.state.hasOwnProperty(name)) {
      this.setState({
        [name]: value,

      });
    }

  };
  handleDownload = async () => {
    this.setState({
      modal: true
    })
    this.props.handleSubmitDisable()
  
  }

  toggle = () => {
    this.setState({
      modal: !this.state.modal
    })
  }

  render() {
    // let etproducts
    const enabledDates_et = this.props.etdates.map((momentDate) => momentDate.toDate());
    console.log("snow et dates", this.props.etdates,enabledDates_et)


    //console.log("adsadsada",this.props.etmonthly_yrs)
    let etproducts,fnFortnightsOpt, fnMonthsOpt, fnYearsOpt, mnYearsOpt, mnMonthsOpt;
    console.log(this.props.selectionRange)
    if (this.props.etproducts !== null) {

      console.log("this.props.etproducts",this.props.etproducts)
      etproducts = this.props.etproducts.map((product) => {
        if(product === 'Actual Evapotranspiration') return (<option value={product}>Actual Evapotranspiration - Daily 5500m</option>)
        if(product === 'Actual Evapotranspiration monthly') return (<option value={product}>Actual Evapotranspiration - Monthly 5500m</option>)
        if(product === 'Actual Evapotranspiration fortnightly') return (<option value={product}>Actual Evapotranspiration - Fortnightly 5500m</option>)
        if(product === 'Actual Evapotranspiration 750') return (<option value={product}>Actual Evapotranspiration - Daily 750m</option>)
        if(product === 'Actual Evapotranspiration monthly 750') return (<option value={product}>Actual Evapotranspiration - Monthly 750m</option>)
        if(product === 'Actual Evapotranspiration fortnightly 750') return (<option value={product}>Actual Evapotranspiration - Fortnightly 750m</option>)
      })

    }

    if (this.props.etmonthly_yrs) {
      mnYearsOpt = this.props.etmonthly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      console.log('MY1', mnYearsOpt);
    }

    if (this.props.etfortnightly_yrs) {
      fnYearsOpt = this.props.etfortnightly_yrs.map((item) => {
        return (<option value={item}>{item}</option>)
      })
      console.log('FY1', fnYearsOpt);
    }


    if (this.props.etmn_yrMonths) {
      mnMonthsOpt = this.props.etmn_yrMonths.map((item) => {
        // console.log(item.month);
        return (<option value={item.month}>{item.month}</option>)
      })
      // console.log('MY1', mnMonthsOpt);
    }

    if (this.props.etfn_yrMonths) {
      fnMonthsOpt = this.props.etfn_yrMonths.map((item) => {
        // console.log(item.month);
        return (<option value={item}>{item}</option>)
      })
      // console.log('MY1', mnMonthsOpt);
    }


    if (this.props.fn_MnFortnight) {
      fnFortnightsOpt = this.props.fn_MnFortnight.map((item) => {
        // console.log(item.month);
        return (<option value={item}>{item}</option>)
      })
      // console.log('MY1', mnMonthsOpt);
    }
    

    return (
      <div>

        {this.state.modal ? 
        <ETDownloadModal 
        modal={this.state.modal} 
        title="Evapotranspiration" 
        toggle={this.toggle} 
        d1={this.props.d1} 
        d2={this.props.d2} 
        etselectedproduct={this.props.etselectedproduct}

        etmn_selectedYear={this.props.etmn_selectedYear}
        etmn_selectedMonth={this.props.etmn_selectedMonth}

        etfn_selectedYear={this.props.etfn_selectedYear}
        etfn_selectedMonth={this.props.etfn_selectedMonth}
        etfn_selectedFortnight={this.props.etfn_selectedFortnight}
        etfn_selectedFile={this.props.etfn_selectedFile}
        etmn_selectedFile={this.props.etmn_selectedFile}

        theme="ET" 
        product="EB"
        user={window.sessionStorage.getItem("loginUser")}
         /> : null}

        <div className="wrapper_data">
          <div id="one">

            Select Product
                    <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.props.handleETProductChange}
              value={this.props.etproduct}
              selected={this.props.etproduct}
            >
              <option value="#">Select</option>
              {etproducts}

            </select>
          </div>
          <div id="two">
            Availability 

          {/*=============================================================================================================you edit Actual ET 5500M============================================================================================================ */}
            {this.props.etselectedproduct === 'Actual Evapotranspiration' ? 
            (this.props.etstart_date !== null ?
              <p style={{ color: "blue" }}>

                {moment(this.props.etstart_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} - {moment(this.props.etend_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} </p> : null) : this.props.etselectedproduct === 'Actual Evapotranspiration monthly' ? (<p>
                  Select Year<select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.mn_YearChange}
              value={this.props.etmn_selectedYear}
              selected={this.props.etmn_selectedYear}
            >
              <option value="#">Select</option>
              {mnYearsOpt}

            </select> <br/>

            {this.props.etmn_selectedYear && <div>Select Month <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.etmn_setSelectedMonth}
              value={this.props.etmn_selectedMonth}
              selected={this.props.etmn_selectedMonth}
            >
              <option value="#">Select</option>
              {mnMonthsOpt}

            </select></div>}

            {this.props.etmn_selectedYear && this.props.etmn_selectedMonth ? <div>
              <br/><button
                  onClick={this.handleDownload}


                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
              
            </div> : null
            }
             
                </p>) : this.props.etselectedproduct === 'Actual Evapotranspiration fortnightly' ? (<p>

                  Select Year<select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.fn_YearChange}
              value={this.props.etfn_selectedYear}
              selected={this.props.etfn_selectedYear}
            >
              <option value="#">Select</option>
              {fnYearsOpt}

            </select> <br/>


            {this.props.etfn_selectedYear && this.props.etfn_selectedYear!='#' && <div>Select Month <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.etfn_setSelectedMonth}
              value={this.props.etfn_selectedMonth}
              selected={this.props.etfn_selectedMonth}
            >
              <option value="#">Select</option>
              {fnMonthsOpt}

            </select> <br/></div>}


            {this.props.etfn_selectedYear && this.props.etfn_selectedMonth!='#' && this.props.etfn_selectedMonth  && <div>Select Fortnight <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.etfn_setSelectedFortnight}
              value={this.props.etfn_selectedFortnight}
              selected={this.props.etfn_selectedFortnight}
            >
              <option value="#">Select</option>
              {fnFortnightsOpt}

            </select></div>}

            {this.props.etfn_selectedYear && this.props.etfn_selectedMonth  && this.props.etfn_selectedMonth!='#'  && this.props.etfn_selectedFortnight && this.props.etfn_selectedFortnight!='#' ? <div>
            <br/><button
                  onClick={this.handleDownload}


                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
              
            </div> : null
            }
                </p>) 
                : null }

{/*=============================================================================================================you edit Actual ET 750M============================================================================================================ */}

{this.props.etselectedproduct === 'Actual Evapotranspiration 750' ? 
            (this.props.etstart_date !== null ?
              <p style={{ color: "blue" }}>

                {moment(this.props.etstart_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} - {moment(this.props.etend_date, "YYYY-MM-DD").format("DD-MMM-YYYY")} </p> : null) : this.props.etselectedproduct === 'Actual Evapotranspiration monthly 750' ? (<p>
                  Select Year<select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.mn_YearChange}
              value={this.props.etmn_selectedYear}
              selected={this.props.etmn_selectedYear}
            >
              <option value="#">Select</option>
              {mnYearsOpt}

            </select> <br/>

            {this.props.etmn_selectedYear && <div>Select Month <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.etmn_setSelectedMonth}
              value={this.props.etmn_selectedMonth}
              selected={this.props.etmn_selectedMonth}
            >
              <option value="#">Select</option>
              {mnMonthsOpt}

            </select></div>}

            {this.props.etmn_selectedYear && this.props.etmn_selectedMonth ? <div>
              <br/><button
                  onClick={this.handleDownload}


                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
              
            </div> : null
            }
             
                </p>) : this.props.etselectedproduct === 'Actual Evapotranspiration fortnightly 750' ? (<p>

                  Select Year<select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.fn_YearChange}
              value={this.props.etfn_selectedYear}
              selected={this.props.etfn_selectedYear}
            >
              <option value="#">Select</option>
              {fnYearsOpt}

            </select> <br/>


            {this.props.etfn_selectedYear && this.props.etfn_selectedYear!='#' && <div>Select Month <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.etfn_setSelectedMonth}
              value={this.props.etfn_selectedMonth}
              selected={this.props.etfn_selectedMonth}
            >
              <option value="#">Select</option>
              {fnMonthsOpt}

            </select> <br/></div>}


            {this.props.etfn_selectedYear && this.props.etfn_selectedMonth!='#' && this.props.etfn_selectedMonth  && <div>Select Fortnight <select style={{ width: "250px", backgroundColor: colors["sidebar-sub-menu"], color: colors.white }}
              onChange={this.etfn_setSelectedFortnight}
              value={this.props.etfn_selectedFortnight}
              selected={this.props.etfn_selectedFortnight}
            >
              <option value="#">Select</option>
              {fnFortnightsOpt}

            </select></div>}

            {this.props.etfn_selectedYear && this.props.etfn_selectedMonth  && this.props.etfn_selectedMonth!='#'  && this.props.etfn_selectedFortnight && this.props.etfn_selectedFortnight!='#' ? <div>
            <br/><button
                  onClick={this.handleDownload}


                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
              
            </div> : null
            }
                </p>) 
                : null }
          </div>
        </div>

      {/*============================================================================================================================it ends=====================================================================================================================*/}

       {/*=================================================================================================================ACTUAL ET 5500m DATE SELECTION =======================================================================================================*/}
        {this.props.etselectedproduct === 'Actual Evapotranspiration' || this.props.etselectedproduct === 'Actual Evapotranspiration 750' && this.props.selectionRange !== null && this.props.etend_date !== null ?
          <div className="wrapper_data">
            <div id="one">


              Date Range Selection
                <br />   <DateRange

               ranges={[this.props.selectionRange]}
                onChange={this.props.handleSelect}
                moveRangeOnFirstSelection={false}
                minDate={new Date(this.props.etstart_date)}
                maxDate={new Date(this.props.etend_date)}

                dayContentRenderer={(date) => {
                  const enabledDates_et = this.props.etdates.map((momentDate) => momentDate.toDate());
              
                  const isAvailable = enabledDates_et.some(
                    (enabledDate) =>
                      enabledDate.toISOString().split("T")[0] === date.toISOString().split("T")[0]
                  );
                  return (
                    <div
                      style={{
                        backgroundColor: isAvailable ? "#90EE90" : "transparent", // Light green for available dates
                         borderRadius: "50%",
                         color:"black",
                        // paddingTop: "10px",
                        // paddingLeft:"10px",
                        // paddingRight:"10px",
                        // paddingBottom:"-10px",
                        padding:"10px",


                        textAlign:"center",
                      }}
                    >
                      {date.getDate()}
                    </div>
                  );
                }}
              /><br />

            </div>
            <div id="two">
              {this.props.date1 !== null ? <Message size='small'>
                Selected Dates:&nbsp; {
                  moment(this.props.date1, "DD-MM-YYYY").format(
                    "DD-MMM-YYYY")} - {moment(this.props.date2, "DD-MM-YYYY").format(
                      "DD-MMM-YYYY")}
              </Message> : null}
              {!this.props.submitdisable ?
                <button
                  onClick={this.handleDownload}

                  className="btn btn-primary text-capitalize"
                >
                  Submit
            </button>
                : null}
              {/* <Message warning>* Maximum downloadable products are 10 at a time.</Message> */}

            </div>
          </div> : null}
           
      </div>

    )
  }
}
 {/*======================================================================================================================newly added---ACTUAL ET- 750M DATE RANGE SELECTION FUNCTION ========================================================================= */}

    {/* this.props.etselectedproduct === 'Actual Evapotranspiration 750' && this.props.selectionRange !== null && this.props.etend_date !== null ?
    <div className="wrapper_data">
      <div id="one">
        Date Range Selection
          <br />   <DateRange
          ranges={[this.props.selectionRange]}
          onChange={this.props.handleSelect}
          moveRangeOnFirstSelection={false}
          minDate={new Date(this.props.etstart_date)}
          maxDate={new Date(this.props.etend_date)}
        /> <br />

      </div>
      <div id="two">
        {this.props.date1 !== null ? <Message size='small'>
          Selected Dates:&nbsp; {
            moment(this.props.date1, "DD-MM-YYYY").format(
              "DD-MMM-YYYY")} - {moment(this.props.date2, "DD-MM-YYYY").format(
                "DD-MMM-YYYY")}
        </Message> : null}
        {!this.props.submitdisable ?
          <button
            onClick={this.handleDownload}
            className="btn btn-primary text-capitalize"
          >
            Submit
      </button>
          : null}
            </div>
          </div> : null}
        <Message warning>* Maximum downloadable products are 10 at a time.</Message> */}

  {/*======================================================================================================================ACTUAL ET- 750M ENDS==================================================================================================================*/}

const mapStateToProps = (state) => ({
  availableDates: state.ETState.dates,
  date: state.ETState.date,

});
export default connect(mapStateToProps, {
  getETDates,

  handleDateChange,

})(ETTable);